export const Seo = ({ title, description, noindex = false }) => (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    {noindex && <meta name="robots" content="noindex,nofollow" />}
  </>
);
